var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1.35C2.08873 1.35 1.35 2.08873 1.35 3C1.35 3.91127 2.08873 4.65 3 4.65C3.91127 4.65 4.65 3.91127 4.65 3C4.65 2.08873 3.91127 1.35 3 1.35ZM0.15 3C0.15 1.42599 1.42599 0.15 3 0.15C4.57401 0.15 5.85 1.42599 5.85 3C5.85 4.57401 4.57401 5.85 3 5.85C1.42599 5.85 0.15 4.57401 0.15 3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronCircle);
export default __webpack_public_path__ + "static/media/chevron-circle.e15b274eba3c454de2bca0af708c6b77.svg";
export { ForwardRef as ReactComponent };